import { render } from "./InputTextarea.vue?vue&type=template&id=094206e9&ts=true"
import script from "./InputTextarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputTextarea.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/InputTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "094206e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('094206e9', __exports__)) {
    console.log('reload')
    api.reload('094206e9', __exports__)
  }
  
  module.hot.accept("./InputTextarea.vue?vue&type=template&id=094206e9&ts=true", () => {
    console.log('re-render')
    api.rerender('094206e9', render)
  })

}


export default __exports__